import { Navigate, useLocation } from 'react-router-dom';
import { getStoredAuthResult } from '@/services/auth';
import storage from '@/utils/storage';

const RestrictedRoute = ({ children }: any) => {
  const location = useLocation();
  const config = storage.getItem('config');

  let route = '';

  switch (true) {
    case config?.otp_login:
      route = '/auth/login-with-mobile-otp';
      break;
    case !config?.sso_logout_url:
      route = '/get-started';
      break;
    default:
      route = config?.sso_logout_url || '/get-started';
  }

  const authToken = getStoredAuthResult();
  if (!authToken?.webAccessToken) {
    return <Navigate to={route} state={{ from: location }} />;
  }

  return children;
};

export default RestrictedRoute;
